import { useSession } from '#pplx/frontend/auth/useSession.js';
import { useStringFlagValue } from '#pplx/frontend/experimentation/hooks.js';
// The flag evaluates with the default user subject; per-org assignment comes
// from Eppo targeting rules on the `org_uuid` evaluation-context attribute.
// skillservice resolves the same flag keyed by org id and sends the same
// `org_uuid` attribute, so one rule set rings both sides together.
const DEFAULT_MODE = 'shadow';
const KNOWN_MODES = new Set(['off', 'shadow', 'enforce']);
function parseMode(value) {
    return KNOWN_MODES.has(value)
        ? value
        : DEFAULT_MODE;
}
export function useOrgSkillEntitlementMode() {
    const { session } = useSession();
    const orgUUID = session?.user?.org_uuid;
    const hasOrgContext = Boolean(orgUUID && orgUUID !== 'none');
    const { variation: value, loading } = useStringFlagValue({
        flag: 'org-skill-entitlement-mode',
        defaultValue: DEFAULT_MODE,
        skip: !hasOrgContext,
    });
    return {
        mode: hasOrgContext ? parseMode(value) : DEFAULT_MODE,
        loading,
    };
}
//# sourceMappingURL=useOrgSkillEntitlementMode.js.map